<template>
  <div class="">
    <div class="flex mb-2" @click="changePage('index')">
      <span class="font-semibold uppercase text-gray-600"><i class="material-icons mr-2">arrow_back</i></span><strong class="pb-4 uppercase text-gray-600">Back</strong>
    </div>
    <form @submit.prevent="add">
      <div class="flex pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            New Account
          </h3>
          <p class="text-gray-600">Add a new account!</p>
        </div>
        <div class="w-2/3">
          <div class="flex space-x-4 mt-4">
            <label class="block w-1/2">
              <span class="text-gray-700">First Name</span>
              <input
                v-model="firstName"
                class="form-input block w-full"
                placeholder="Abbay"
              />
            </label>
            <label class="block w-1/2">
              <span class="text-gray-700">
                Last Name
              </span>
              <input
                v-model="lastName"
                class="form-input block w-full"
                placeholder="Kassa"
              />
            </label>
          </div>
          <div class="flex space-x-4 mt-4">
            <label class="block w-1/2">
              <span class="text-gray-700">
                Email
              </span>
              <input
                v-model="email"
                class="form-input block w-full"
                type="email"
                placeholder="contact@sheraton.com"
              />
            </label>
            <label class="block w-1/2">
              <span class="text-gray-700">
                Password
              </span>
              <input
                v-model="password"
                class="form-input block w-full"
                type="Password"
                placeholder="contact@sheraton.com"
              />
            </label>
            <label class="block w-1/2 mt-2">
              <span class="text-gray-700">
                Confirm Password
              </span>
              <input
                v-model="confirmPassword"
                class="form-input block w-full"
                type="password"
                placeholder="contact@sheraton.com"
              />
            </label>
          </div>
          <div class="mt-4">
            <button
              :disabled="busy"
              class="w-32 py-2 text-ilift-900 rounded shadow"
              :class="
                busy
                  ? 'bg-ilift-200 cursor-not-allowed'
                  : 'bg-ilift-500 hover:bg-ilift-600'
              "
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["corporate", "changePage"],
  data() {
    return {
      busy: false,
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: ""
    };
  },
  methods: {
    add() {
      if (this.password != "" && this.password == this.confirmPassword) {
        var data = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          password: this.password,
          corporate: this.corporate._id,
          roles: [4]
        };
        console.log(data);
        this.busy = true;
        this.$http
          .post("/accounts", data)
          .then(() => this.changePage("index"))
          .catch(err => console.log(err))
          .finally(() => (this.busy = false));
      }
    }
  }
};
</script>
